import { Grid } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import { appNote, ViewTextLabels } from "../shared/constants";
import StepInputControl from "../shared/step-input-control/step-input-control.component";
import { CorrectIcon } from "../../icon";
import ButtonComponent from "../shared/button/button.component";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"

interface IProps {
    StepLength: number;
    NumOfSteps: number;
    IsNumberInput: boolean;
    HandleOnChangeStepValue: (otp: any) => void;
    Value: string;
    ErrorMessage: string;
    ResendOtp: () => void;
    VerifyOtp: (e: any) => void;
    IsValid: boolean;
    ResendLabel: string;
    Title: string;
    SetWidth?: string;
    ShowResendTimer?: boolean;
    ResendTime: 15 | 30 | 45 | 60;
    IsLoading?: boolean;
    ButtonLabel?: string;
    ExceedCount?: boolean;
    IsSignUpBtn?: boolean;
    WrongAttemptsDisplayMsg?: string;
    WrongAttemptsBtnLabel?: string;
    WrongAttemptsBtnPath?: string;
    OtpTextFieldColor?: string;
    IsUnAuthScreen?: boolean;
    IsBackTologin?: boolean;
}

const SecureFileOtpVerifcation = (props: IProps) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const timer = useRef<NodeJS.Timeout>(null)
    const [timerClock, setTimerClock] = useState<number>(props.ResendTime)

    useEffect(() => {
        setupTimer()
        return () => {
            clearTimer()
        }
    }, [])

    useEffect(() => {
        if (props.ShowResendTimer) {
            setTimerClock(isNaN(timerClock) ? props.ResendTime : timerClock)
            setupTimer()
        }
        else {
            clearTimer()
        }
    }, [props.ShowResendTimer])

    const clearTimer = () => {
        if (timer.current) {
            clearInterval(timer.current);
            setTimerClock(NaN)
        }
    }

    const setupTimer = () => {
        if (timer) {
            clearInterval(timer.current);
        }
        timer.current = setInterval(() => {
            setTimerClock((previousProps) => {
                const NewTimerClock = previousProps - 1
                if (!NewTimerClock) {
                    clearInterval(timer.current)
                }
                return NewTimerClock
            })
        }, 1000)
    }

    return (
        <>
            {
                !props.IsValid ?
                    <div className={`${!props.IsUnAuthScreen ? `b-around-primary-dark-1 br-2` : `d-flex flex-direction`} p-2`}>
                        <div className={`h5-regular mx-auto color-twoFa-label`}> {props.Title} </div>
                        <Grid container className={"mt-1"}>
                            <Grid item md={12} sm={12} xs={12} lg={12} className={`${props.IsUnAuthScreen && 't-align-center'}`}>
                                <StepInputControl stepLength={props.StepLength} numOfSteps={props.NumOfSteps} isNumberInput={props.IsNumberInput}
                                    handleOnChangeStepValue={(otp) => props.HandleOnChangeStepValue(otp)} setWidth={props.SetWidth} disabled={props.ExceedCount} OtpTextFieldColor={props.OtpTextFieldColor} />
                            </Grid>
                            <Grid item xs={9} sm={9} md={9} lg={9} xl={9} className={"mx-auto"}>
                                <ButtonComponent
                                    OnClick={props.VerifyOtp}
                                    Variant={"primary-btn"}
                                    Loading={props.IsLoading}
                                    ButtonLabel={props.ButtonLabel ? props.ButtonLabel : "Verify OTP"}
                                    ClassName={`c-pointer w-fill justify-center primary-btn w-space ${IsMobileDevice ? "h2" : "h4-regular"} ${((props.Value?.length < props.NumOfSteps) && !props.ExceedCount) && "disabled disabled-btn"} d-block`}
                                    buttonProps={{
                                        tabIndex: 5,
                                        "data-arrow-index": props.NumOfSteps + 2,
                                        "data-up-arrow-index": props.NumOfSteps + 1,
                                        "data-down-arrow-index": props.NumOfSteps + 2,
                                        "data-left-arrow-index": props.NumOfSteps + 2,
                                        "data-right-arrow-index": props.NumOfSteps + 2
                                    }}></ButtonComponent>
                            </Grid>
                            <Grid item md={12} sm={12} xs={12} className="d-flex justify-center mb-1">
                                {!!props.ErrorMessage && <span className={`color-primary-danger h5-regular t-align-center ${IsMobileDevice && "h5-regular"}`}>
                                    {props.ErrorMessage === 'file not found' ?
                                        <div className={`color-primary-danger justify-center h5-regular d-flex flex-direction align-center mb-1 `}>
                                            <span >
                                                {"The requested file has been deleted by the Sender."}
                                            </span>
                                            <span>
                                                {"Please contact the sender for further assistance. "}
                                            </span>
                                        </div>
                                        : props.ErrorMessage} </span>}
                            </Grid>
                            <Grid item md={12} sm={12} xs={12} className={`w-space ${props.IsUnAuthScreen && 't-align-center'} mb-1`}>
                                {!props.ExceedCount && <span className={"twofa-didnot-recive-label color-twoFa-label"}>
                                    {appNote.DID_NOT_RECEIVE}
                                    {
                                        props.ShowResendTimer && timerClock ?
                                            <span>
                                                {props.ResendLabel + " in "}
                                                <span>{timerClock} {ViewTextLabels.SECONDS}</span>
                                            </span>
                                            :
                                            <button tabIndex={6}
                                                data-arrow-index={props.NumOfSteps + 1}
                                                data-up-arrow-index={1}
                                                data-down-arrow-index={props.NumOfSteps + 2}
                                                data-left-arrow-index={props.NumOfSteps + 1}
                                                data-right-arrow-index={props.NumOfSteps + 1} className={`h5-regular color-primary-light c-pointer`} onClick={props.ResendOtp}> {props.ResendLabel}
                                            </button>
                                    }
                                </span>}
                            </Grid>
                        </Grid>

                    </div>
                    :
                    <div>
                        <div className="d-flex justify-center">
                            <CorrectIcon className={`w-6 h-6`} />
                        </div>
                        <div className={"mb-1 d-flex justify-center mt-3 mb-3"}>
                            <span className={`h2-medium color-display-content t-align-center `}>
                                {appNote.FILE_DOWNLOAD_SUCCESS}
                            </span>
                        </div>
                    </div>
            }
        </>
    );
}

export default SecureFileOtpVerifcation;